module.exports = __webpack_public_path__ + "static/media/defaultCityImage.efe520ab.png";